import dynamic from 'next/dynamic';

export const ContentHeader = dynamic(() => import('./ContentHeader'));
export const Breadcrumb = dynamic(() => import('./Breadcrumb'));
export const ContentBlock = dynamic(() => import('./ContentBlock'));
export const BlockContainer = dynamic(() => import('./BlockContainer'));
export const ContentPageTemplate = dynamic(() => import('./ContentPageTemplate'));
export const ContentBoxWithImage = dynamic(() => import('./ContentBoxWithImage'));
export const ContentUsps = dynamic(() => import('./ContentUsps'));
export const InspiringImages = dynamic(() => import('./InspiringImages'));
export const InspiringImage = dynamic(() => import('./InspiringImage'));

export default dynamic(() => import('./ContentHeader'));
